<template>
  <div>
    <div class="contain">
      <!--三个导航片段-->
      <div v-if="id==6">
        <link-c></link-c>
      </div>
      <!--注册-->
      <div v-if="id=='reg'">
        <register></register>
      </div>
      <!--注册-->
      <div v-if="id=='reset'">
        <resetpass></resetpass>
      </div>
      <!--login-->
      <div v-if="id=='login_cn'">
        <login></login>
      </div>
      <!--ims-->
      <div v-if="id==316">
        <ims></ims>
      </div>
      <!--后台返回的html片段-->
      <div v-if="id!=6&&id!=='reg'&&id!=='login'" v-html="delHtml"></div>
    </div>
  </div>
</template>
<script>
  import linkC from '../components/tiantan/link_c'
  import ico1 from '../imgs/ico1.png'
  import ico2 from '../imgs/ico2.png'
  import ico3 from '../imgs/ico3.png'
  import ico4 from '../imgs/ico4.png'
  import ico5 from '../imgs/ico5.png'
  import ico6 from '../imgs/ico6.png'
  import ico7 from '../imgs/ico7.png'
  import register from '../components/tiantan/register_cn'
  import resetpass from '../components/tiantan/resetpass_cn'
  import login from '../components/tiantan/login_cn'
  import ims from '../components/tiantan/ims'
  export default {
    data() {
      return {
        id: 0,
        exitActive: false, //用户退出状态，false为未登录 true为登录
        flag: false, //是否打开登录框
        activeTab: 0,
        delHtml: '',
        navs: [
//            `Home  News  Organization  Guide   Agenda   Submission   Registration`,
          {
            iconClass: 'fa-home',
            imageSrc: ico1,
            text: 'Home',
            child: []
          },
          {
            iconClass: 'fa-newspaper-o',
            imageSrc: ico2,
            text: 'Congress Information',
            child: [
              {
                text: 'Introduction',
                href: '',
                route: false
              }, {
                text: 'Welcome Letter',
                href: '',
                route: true
              }, {
                text: 'General Information',
                href: '',
                route: false
              }, {
                text: 'Organization',
                href: '',
                route: false
              }, {
                text: 'About IMS',
                href: ' http://www.meningiomasociety.org',
                route: false
              }, {
                text: 'About Beijing Tiantan Hospital',
                href: ' http://www.bjtth.org/Html/News/Articles/3724.html',
                route: false
              }
            ]
          },
          {
            iconClass: 'fa-sitemap',
            imageSrc: ico3,
            text: 'Scientific Information',
            child: [
              {
                text: 'Pre-Congress Courses',
                href: '',
                route: false
              }, {
                text: 'Program at a glance',
                href: '/#/home_en/1/detail1/8',
                route: false
              }, {
                text: 'Introduction of the masters',
                href: '',
                route: false
              }, {
                text: 'Abstract Submission',
                href: '/#/home_en/1/detail1/7',
                route: false
              }, {
                text: 'Instruction & Guideline for Speakers',
                href: '',
                route: false
              }, {
                text: 'About Beijing Tiantan Hospital',
                href: '',
                route: false
              }, {
                text: 'Important Dates',
                href: '',
                route: false
              }
            ]
          },
          {
            iconClass: 'fa-superpowers',
            imageSrc: ico4,
            text: 'Social Program',
            child: [
              {
                text: 'Welcome Reception',
                href: '',
                route: false
              }, {
                text: 'Gala Dinner',
                href: '',
                route: false
              }, {
                text: 'Visit New Beijing Tiantan Hopital',
                href: '',
                route: false
              }, {
                text: 'Travel Agent',
                href: '',
                route: false
              }
            ]
          },
          {
            iconClass: 'fa-book',
            imageSrc: ico5,
            text: 'Registration  &  Accommodation',
            child: [
              {
                text: 'Registration',
                href: '',
                route: false
              }, {
                text: 'Accommodation',
                href: '',
                route: false
              }
            ]
//            href:'/home_detail/5'
          },
          {
            iconClass: 'fa-file-word-o',
            imageSrc: ico6,
            text: 'Sponsorship  &  Exhibitions',
            child: [
              {
                text: 'Information for Sponsors and Exhibitors',
                href: '',
                route: false
              }, {
                text: 'Sponsors',
                href: '',
                route: false
              }, {
                text: 'Exhibitors',
                href: '',
                route: false
              }
            ]
          },
          {
            iconClass: 'fa-pencil-square-o',
            imageSrc: ico7,
            text: 'Useful Links',
//            reg: true,
            child: [
              {
                text: 'IMA',
                href: '',
                route: false
              }, {
                text: 'Beijing Tiantan Hospital',
                href: ' http://www.bjtth.org/Html/News/Main/1125.html',
                route: false
              }, {
                text: 'China National Convention Center',
                href: ' http://www.cnccchina.com/en/default.aspx',
                route: false
              }
            ]
          }
        ],
        lists: []
      }
    },
    components: {
      linkC, register,login,ims,resetpass
    },
    computed: {
      list() {
        return this.lists[this.id];
      }
    },
    props: {},
    methods: {
//        获得delhtml
      getData(){
        axios.request({
          url: '/medapp/api/con/info/get',
          method: 'post', // default
          data: {
            info_id: this.$route.params.id
          },
        }).then((response) => {
          console.log(JSON.stringify(response.data.info))
          this.delHtml = response.data.info.infoDesc;
        })
      },
      tab(index, item) {
        this.activeTab = index;
        //        点击注册
        if (item.reg !== undefined) {
          //            如果已经登录了就直接跳转到报名信息页
          let user = localStorage.getItem('user') !== null && localStorage.getItem('user') !== '';
          if (user) {
            this.$router.push('/webpc/sign/add');
            return;
          }
          this.flag = true;
        }
      },
    },
    watch: {
      $route (){
        this.id = this.$route.params.id;
        if (this.id === 'reg' || this.id === 'login'|| this.id==="reset") {
          this.delHtml = '';
          return;
        }
        this.getData();
      }
    },
    mounted() {
      this.id = this.$route.params.id;
      if (this.id === 'reg' || this.id === 'login' || this.id === '316' || this.id==="reset") {
        return;
      }
      this.getData();
    }
  }
</script>
<style scoped>
  .contain {
    color: #000000;
    width: 1200px;
    font-size: 16px;
    border: 1px solid #eeeeee;
    margin: 70px auto 30px;
    padding: 20px;
  }

  p {
    text-indent: 2rem;
  }

  .active-laguage {
    color: #5cadff;
  }

  .exitActive {
    color: #00c261;
  }

  ul,
  li {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .clear:after {
    display: block;
    content: "";
    clear: both;
  }

  .container {
    width: 100%;
    background-color: #000;
  }

  header {
    width: 1200px;
    margin: auto;
    height: 39px;
    color: #fff;
    font-size: 18px;
    /*display: flex;*/
    /*justify-content: flex-end;*/
  }

  header div {
    width: 100px;
    line-height: 39px;
    position: relative;
    float: right;
    display: inline-block;
  }

  .language-line {
    height: 20px;
    border-right: 1px solid #fff;
    position: absolute;
    right: 17px;
    top: 10px;
  }

  .banner {
    width: 100%;
    height: 400px;
    margin: 0 auto;
    text-align: center;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
  }

  .banner .swiper-container,
  .banner .swiper-container .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-img {
    width: 100%;
    height: 100%;
  }

  /*导航*/

  .nav {
    width: 1200px;
    /* height: 80px; */
    bottom: 10px;
    margin: -82px auto 0;
    text-align: left;
    font-size: 14px;
  }

  .nav-box {
    position: relative;
    z-index: 10;
  }

  .nav-box li {
    position: relative;
  }

  .nav-box.fix {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
  }

  .nav li {
    width: 168px;
    padding: 8px 0;
    text-align: center;
    background-color: #ffffff;
    cursor: pointer;
    color: #000000;
    margin-right: 2px;
    float: left;
    line-height: 53px;
  }

  .en-language {
    font-size: 14px;
    color: #a3a3a3;
  }

  .nav li i {
    color: #4C4E82;
    font-size: 27px;
    vertical-align: text-bottom;
  }

  .nav .active-tab {
    background-color: #F39800;
    color: #ffffff;
  }

  .nav .active-tab .en-language {
    color: #ffffff;
  }

  .nav .active-tab i {
    color: #FFFFFF;
  }

  .nav-text {
    /*margin-left: 12px;*/
  }

  .container-box {
    width: 1200px;
    margin: 0 auto;
  }

  .item {
    margin-top: 50px;
  }

  .new {
    color: red;
    font-size: 14px;
    margin-left: 5px;
  }

  .teacher-des {
  }

  .teacher-video {
    width: 794px;
    height: 470px;
    background-color: #000000;
    float: left;
    margin-right: 20px;
  }

  .teacher-font {
    width: 384px;
    float: left;
  }

  .teacher-font h3 {
    font-size: 24px;
    color: #000000;
    font-weight: 400;
  }

  .teacher-title {
    font-size: 14px;
    color: #e6e5e5;
  }

  .teacher-head {
    display: flex;
    border-bottom: 1px solid #E6E5E5;
    margin-bottom: 22px;
    padding-bottom: 22px;
  }

  .teacher-head img {
    width: 152px;
    height: 122px;
    margin-right: 24px;
  }

  .teacher-font-content {
    font-size: 22px;
    color: #000000;
    line-height: 1.5;
    word-break: break-all;
  }

  .author-des {
    width: 1200px;
    height: 548px;
    position: relative;
    background: url("http://www.medicalcircle.cn/lib/tpl/tt.png") no-repeat center center;
    overflow: hidden;
  }

  .author-des .swiper-container {
    height: 100%;
  }

  .author-des .swiper-wraper {
    height: 100%;
  }

  .author-des .swiper-slide {
    position: relative;
    height: 100%;
  }

  .author-des-content {
    /*padding: 25px 48px 25px 48px;*/
    background-color: #2b2d62;
    bottom: 0;
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    color: #FFFFFF;
    /*display: flex;*/
    z-index: 5;
    padding: 30px 48px 29px 48px;
  }

  .author-des-content .author-des-icon {
    float: left;
  }

  .author-des-content .author-des-title {
    width: 1033px;
  }

  .author-des-icon {
    margin-right: 24px;
    margin-top: 6px;
    float: left;
  }

  .author-des-title {
    float: left;
  }

  .author-des-title h3 {
    font-size: 24px;
    font-weight: 500;
  }

  .author-des-title div {
    font-size: 14px;
  }

  .author-des-con {
    transition: all ease-in .2s;
    top: 100%;
    bottom: -100%;
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .author-des-con-box {
    width: 600px;
    font-size: 16px;
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translateX(-50%)
  }

  .author-des-con.active {
    bottom: 107px;
    top: 0;
    right: 0;
    color: #FFFFFF;
    left: 0;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, .3);
  }

  .indent {
    text-indent: 2rem;
  }

  /*最新动态*/

  .top-bar {
    padding: 25px 48px 25px 48px;
    background-color: #f4f4f7;
    /*display: flex;*/
  }

  .dtai {
  }

  .dtai-download-box {
    color: #ffffff;
    float: left;
  }

  .dtai-news-box {
    width: 897px;
    margin-right: 5px;
    float: left;
  }

  .dtai-download-content {
    background-color: #2b2d62;
    margin-top: 8px;
    font-size: 18px;
    width: 298px;
    padding: 30px;
    line-height: 2;
  }

  .dtai-download-content li {
    margin-top: 30px;
    width: 240px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .list-swiper-box {
  }

  .list-swiper-box .swiper-slide img {
    width: 100%;
    height: 257px;
    border: 1px solid #000000;
  }

  .list-swiper-title-box {
    text-align: center;
    border: 1px solid #b0b3ae;
    padding: 0 11px;
    height: 257px;
    margin-top: -5px;
    border-top: 0;
  }

  .list-swiper-title,
  .list-swiper-title2 {
    font-size: 34px;
    color: #1533B7;
    font-weight: 500;
  }

  .list-swiper-title2 {
    font-size: 16px;
    color: #000000;
    /* font-weight: 500; */
    /*text-align: left;*/
    /*text-indent: 2rem;*/
  }

  /*公司底部信息*/

  .brand-box {
    background-color: #141651;
    padding: 27px 73px;
    color: #ffffff;
  }

  .brand-content {
    width: 1200px;
    margin: 0 auto;
  }

  .brand-content-title {
    font-size: 24px;
  }

  .brand-content-title2 {
    font-size: 14px;
    color: #aaaaaa;
    margin-bottom: 30px;
  }

  .brand-box ul {
    line-height: 2;
    font-size: 18px;
    margin-top: 5px;
  }

  .brand-content-box ul {
    float: left;
    /*display: flex;*/
    /*justify-content: space-between;*/
  }

  .address {
    margin-right: 12px;
  }

  .erwm {
    width: 148px;
    height: 148px;
    background-color: #FFFFFF;
    float: right;
  }

  .download-btn {
    cursor: pointer;
  }

  .fangan1 {
    float: left;
    width: 33.33%;
    padding: 30px;
    box-sizing: border-box;
  }

  .fangan1 > img {
    width: 100%;
    height: 246px;
  }

  #_nav .nav-child {
    position: absolute;
    left: 0;
    top: 100%;
    background-color: #FFFFFF;
    font-size: 14px;
    line-height: 2em;
    /*padding-bottom: 20px;*/
    z-index: 100;
    width: 100%;
  }

  .nav-child-item {
    color: #000;
  }

  .nav-child-item:hover {
    color: #ffffff;
    background-color: #F39800;
  }
</style>





// WEBPACK FOOTER //
// temp_view_cn.vue?05fdf734